import React, { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showSnackBar } from '../../../redux/Slices/snackbarSlice';
import { config } from '../../../config';
import { setSelectedBackground } from '../../../redux/Slices/boardSlice';

// Lightweight debounce to optimize rapid clicks
const debounce = (fn, delay = 300) => {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), delay);
    };
};

const Colors = () => {
    const { board } = useSelector((state) => state.board);
    const boardId = board?.shortId;
    const dispatch = useDispatch();

    // Only color backgrounds (removed "No background" option)
    const items = useMemo(() =>
        Array.from({ length: 6 }, (_, i) => {
            const idx = i + 1;
            return {
                id: `color-${idx}`,
                url: `https://cloud.zoobbe.com/backgrounds/colors/color-${idx}.svg`,
                label: `Color ${idx}`,
            };
        }),
        []
    );

    const saveBackground = useCallback(
        debounce(async (url) => {
            if (!boardId) return;
            try {
                const res = await fetch(`${config.API_URI}/v1/boards/boards-background`, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({ url, boardId }),
                });
                if (!res.ok) {
                    const err = await res.text();
                    throw new Error(`${res.status} ${err}`);
                }
            } catch (e) {
                console.error('Failed to set background:', e);
                dispatch(showSnackBar({ message: 'Failed to set background', type: 'error' }));
            }
        }, 250),
        [boardId, dispatch]
    );

    // Auto-apply on click with optimistic preview and debounced save
    const handleSelect = (url) => {
        dispatch(setSelectedBackground(url));
        saveBackground(url);
    };

    return (
        <div className="add-attachment">
            <div className="group">
                <h3 className="background-group-title">Choose a color background</h3>
                <div className="zoobbe-background-colors">
                    <div className="unsplash-images">
                        {items.map((bg) => (
                            <div className="board-background-select" key={bg.id}>
                                <span
                                    className="background-box"
                                    style={{ backgroundImage: `url('${bg.url}')` }}
                                    onClick={() => handleSelect(bg.url)}
                                    title={bg.label}
                                >
                                    <div className="large">{bg.label}</div>
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Colors;
